module.exports = __webpack_public_path__ + "img/hdmd2.9e9f2ea0.jpg";